module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "payZfb"
    }
  }, [_c('div', {
    staticClass: "paySuc-sec"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "suc-operate-group"
  }, [_c('span', {
    staticClass: "op-items",
    on: {
      "click": function($event) {
        _vm.checkPaySec(0)
      }
    }
  }, [_vm._v("已完成支付")]), _vm._v(" "), _c('span', {
    staticClass: "op-items",
    on: {
      "click": function($event) {
        _vm.checkPaySec(1)
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-group"
  }, [_c('div', {
    staticClass: "suc-img"
  }, [_c('span', {
    staticClass: "pay-zfb-icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/payXfb.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "tips"
  }, [_vm._v("请在菜单中选择在浏览器中打开，"), _c('br'), _vm._v("以完成支付~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa6edcfa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/payZFB.vue
// module id = 587
// module chunks = 1